<template>
    <div :class="catalogGridClasses">
        <template
            v-for="(product, index) in products"
            :key="product[keyProperty]"
        >
            <slot
                v-if="
                    gridInjectionIndexes &&
                        gridInjectionIndexes.includes(index) &&
                        $slots.inGridContent
                "
                name="inGridContent"
                :contentfulInGridContent="inGridContentByInjectionIndex[index]"
            ></slot>
            <LazyLoad
                :class="catalogTileClasses"
                bottomMargin="100px"
                v-slot="{ hasEnteredViewport }"
            >
                <slot
                    :index="index"
                    :product="product"
                    :hasEnteredViewport="hasEnteredViewport"
                ></slot>
            </LazyLoad>
            <template v-if="index === products.length - 1">
                <template
                    v-for="injectionIndex in gridInjectionIndexes"
                    :key="gridInjectionIndexes[injectionIndex]"
                >
                    <slot
                        v-if="injectionIndex && index === products.length - 1 && injectionIndex > products.length - 1"
                        name="inGridContent"
                        :contentfulInGridContent="
                            inGridContentByInjectionIndex[injectionIndex]
                        "
                    ></slot>
                </template>
            </template>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import LazyLoad from '~coreModules/core/components/ui/LazyLoad.vue';

const props = defineProps({
    products: {
        type: Array,
        required: true,
    },
    keyProperty: {
        type: String,
        default: '',
    },
    catalogGridClasses: {
        type: [String, Object],
        default: 'o-row',
    },
    catalogTileClasses: {
        type: [String, Object],
        required: true,
    },
    contentfulInGridContentRows: {
        type: Array,
        default: () => [],
    },
    pagination: {
        type: Object,
        default: () => {},
    },
});

const TOTAL_ROWS_PER_PAGE = 24;
const PRODUCTS_PER_ROW = 4;

function inGridProductInjectionIndex(row) {
    return ((row - 1) * PRODUCTS_PER_ROW);
}

// determines injection index based off target page and containing content combination
const gridInjectionIndexes = computed(() => (props.contentfulInGridContentRows || [])
    .flatMap((content) => {
        const targetPageNumber = Math.ceil(content.rowNumber / TOTAL_ROWS_PER_PAGE);
        const row = props.pagination.pageNumber === 1 ? content.rowNumber : (content.rowNumber % TOTAL_ROWS_PER_PAGE);
        return targetPageNumber === props.pagination.pageNumber ? inGridProductInjectionIndex(row) +
                (!content?.leftContent && content?.rightContent ? 2 : 0) : null;
    }));

// creates object that assigns injection index with the contained content
const inGridContentByInjectionIndex = computed(() => (props.contentfulInGridContentRows || [])
    .reduce((result, content) => {
        const row = props.pagination.pageNumber === 1 ? content.rowNumber : (content.rowNumber % TOTAL_ROWS_PER_PAGE);
        const injectionIndex = inGridProductInjectionIndex(row) +
            (!content?.leftContent && content?.rightContent ? 2 : 0);
        // eslint-disable-next-line no-param-reassign
        result[injectionIndex] = { ...content, injectionIndex };
        return result;
    }, {}));

</script>

<style lang="scss">

</style>
